import React, { useEffect, useState } from "react";
import Layout from "../Layout";
import { useLocation } from "react-router-dom";
import List from "../Components/PopUpGiftRequest/List";
import View from "../Components/PopUpGiftRequest/View";
import Add from "../Components/PopUpGiftRequest/Add";

function PopupGiftRequest() {
  const [comp, setComp] = useState("list");
  const [rowData, setRowData] = useState({});
  const location = useLocation();

  useEffect(() => {
    setComp("list");
  }, [location]);

  function handleChange(newValue) {
    setComp(newValue.mode);
    setRowData(newValue.rowData);
  }

  return (
    <Layout>
      <div className="main-content">
        <section className="section">
          <div className="section-header">
            <h1>Direct Pop</h1>
          </div>

          {comp === "list" ? (
            <List comp={comp} onChange={handleChange} rowData={rowData} />
          ) : comp === "view" ? ( // Check if comp is "scan"
            <View comp={comp} rowData={rowData} onChange={handleChange} />
          ) : (
            <Add comp={comp} rowData={rowData} onChange={handleChange} />
          )}
        </section>
      </div>
    </Layout>
  );
}

export default PopupGiftRequest;
